

// effect on scroll with nav sidebar
function navSidebarScroll() {

    // configura o offset
    var headerType = $("#header-home").attr('data-headertype');
    var offsetTrigger = "";
    if (headerType == "home") {
        offsetTrigger = 400;
    } else {
        offsetTrigger = -100;
    }

    // var triggerNav = new Waypoint({
    //     element: document.getElementById('trigger-sidebar'),
    //     handler: function(direction) {
    //         navDirection = direction;
    //
    //         if (direction == 'down') {
    //
    //             var morphingNavShape = anime({
    //                 targets: '.js_nav-sidebar__shape-path',
    //                 d: [
    //                     { value: 'M0.000,0.000 C28.511,0.000 884.000,0.000 884.000,0.000 L884.000,395.009 C346.940,340.571 381.626,71.989 0.000,0.000 Z' }
    //                 ],
    //                 easing: 'easeInOutCubic',
    //                 duration: 1000,
    //                 delay: 400,
    //             });
    //             var navShapeWidth = anime({
    //                 targets: '.nav-sidebar__shape',
    //                 width: navMinWidth,
    //                 easing: 'easeInOutCubic',
    //                 duration: 1100,
    //                 delay: 400,
    //             });
    //             var navTextIcon = anime({
    //                 targets: '.nav-sidebar__btn',
    //                 top: navTextTopMin,
    //                 right: navTextRightMin,
    //                 easing: 'easeInOutCubic',
    //                 duration: 1100,
    //                 delay: 400,
    //             });
    //
    //         } else {
    //
    //             var morphingNavShape = anime({
    //                 targets: '.js_nav-sidebar__shape-path',
    //                 d: [
    //                     { value: 'M0.000,0.000 C28.511,0.000 884.000,0.000 884.000,0.000 L884.000,395.009 C346.940,340.571 259.456,107.689 0.000,0.000 Z' },
    //                     { value: 'M0.000,0.000 C28.511,0.000 884.000,0.000 884.000,0.000 L884.000,395.009 C346.940,340.571 381.626,71.989 0.000,0.000 Z' }
    //                 ],
    //                 easing: 'easeInOutCubic',
    //                 duration: 1000
    //             });
    //             var NavShapeWidth = anime({
    //                 targets: '.nav-sidebar__shape',
    //                 width: navMaxWidth,
    //                 easing: 'easeInOutCubic',
    //                 duration: 1100
    //             });
    //             var NavTextIcon = anime({
    //                 targets: '.nav-sidebar__btn',
    //                 top: navTextTopMax,
    //                 right: navTextRightMax,
    //                 easing: 'easeInOutCubic',
    //                 duration: 1100
    //             });
    //         }
    //     },
    //     offset: offsetTrigger
    // });

}

// resize on nav controls
function navSidebarResize(e) {
    if (navOpen == false) {
        if (navDirection == "down") {
            $('.nav-sidebar__shape').css("width", navMinWidth);
            $('.nav-sidebar__btn').css({"top": navTextTopMin, "right": navTextRightMin});
        } else {
            $('.nav-sidebar__shape').css("width", navMaxWidth);
            $('.nav-sidebar__btn').css({"top": navTextTopMax, "right": navTextRightMax});
        }
    }
}


// timeout control click btn nav
$('#js_nav-sidebar-btn').click(function() {
    if (navClickDisabled) {
        // clickDisabled=true - desabilitado, retorna nada
        return;
    }
    navToggle();
    // desabilita temporario o click
    navClickDisabled = true;
    setTimeout(function(){
        navClickDisabled = false;
    }, 1100);
});


// toggle open and closed nav
function navToggle() {
    if (navOpen == true) {
        navSidebarClose(navDirection);
    } else {
        navSidebarOpen();
    }
}


// open sidebar
function navSidebarOpen() {

    var NavShapeWidth = anime({
        targets: '.nav-sidebar__shape',
        width: '3500px',
        easing: 'easeInOutCubic',
        duration: 1200
    });


    var NavShapePath = anime({
        targets: '.js_nav-sidebar__shape-path',
        d: [
            { value: 'M-0.000,-0.000 C28.511,-0.000 884.000,-0.000 884.000,-0.000 L884.000,395.009 C549.440,211.571 237.626,472.489 -0.000,-0.000 Z' }
        ],
        easing: 'easeInOutCubic',
        duration: 900
    });

    // animacao de texto e icone do menu
    var morphingNavBtnIcon_tl = anime.timeline({
        easing: 'easeInOutCubic',
        duration: 200
    });
    morphingNavBtnIcon_tl
        .add({
            targets: '.js_nav-sidebar__icon-path-03',
            scaleX: 0,
            opacity: 0,
        })
        .add({
            targets: '.js_nav-sidebar__icon-path-02',
            scaleX: 0,
            opacity: 0,
        }, '-=50')
        .add({
            targets: '.js_nav-sidebar__icon-path-01',
            scaleX: 0,
            opacity: 0,
        }, '-=50')
        .add({
            targets: '.js_nav-sidebar__icon-path-04',
            opacity: 1,
            scaleX: [0,1],
        })
        .add({
            targets: '.js_nav-sidebar__icon-path-05',
            opacity: 1,
            scaleX: [0,1],
        }, '-=50');

    var morphingNavBtnText_tl = anime.timeline({
        easing: 'easeInOutCubic',
        duration: 100
    });
    morphingNavBtnText_tl
        .add({
            targets: '.js_nav-sidebar__text-span',
            opacity: 0,
        })
        .add({
            targets: '.js_nav-sidebar__text-span',
            update:function(anim) {
                setTimeout(function () {
                    $('.js_nav-sidebar__text-span').html("VOLTAR");
                }, 200);
            },
            opacity: 1,
            delay: 450,
        });


    $('.nav-sidebar__aside').css("display", "block");

    // animacao do aside
    setTimeout(function () {
        // animacao login
        var asideLogin_tl = anime.timeline({
            easing: 'easeInOutCubic',
            duration: 600,
        });
        asideLogin_tl
            .add({
                targets: '.aside-login',
                opacity: 1,
                translateX: [-80,0],
            })
            .add({
                targets: '.aside-login__nav .el',
                opacity: 1,
                translateX: [-20,0],
                delay: function(el, i, l) {
                    return i * 100;
                },
                endDelay: function(el, i, l) {
                    return (l - i) * 100;
                }
            }, '-=500');


        var asideNav = anime({
            targets: '.nav-sidebar__aside-nav .el',
            easing: 'easeInOutCubic',
            translateX: [-80,0],
            opacity: 1,
            duration: 700,
            delay: function(el, i, l) {
                return i * 100;
            },
            endDelay: function(el, i, l) {
                return (l - i) * 100;
            }
        });
    }, 300);

    setTimeout(function () {
        var asideSocial_tl = anime.timeline({
            easing: 'easeInOutCubic',
            duration: 800,
        });
        asideSocial_tl
            .add({
                targets: '.aside-social',
                opacity: 1,
                translateX: [-80,0],
            })
            .add({
                targets: '.aside-social__nav .el',
                opacity: 1,
                translateX: [-30,0],
                delay: function(el, i, l) {
                    return i * 100;
                },
                endDelay: function(el, i, l) {
                    return (l - i) * 100;
                }
            }, '-=500');
    },600);


    // trata scroll
    $('body').css("overflow-y", "hidden");
    $('#nav-sidebar').css({
        "width": "100%",
        "height": "100%",
        "overflow-y": 'scroll'
    });

    navOpen = true;
}


// close sidebar
function navSidebarClose() {
    var navWidthResize = "";

    if (navDirection == "down") {
        navWidthResize = navMinWidth;
    } else {
        navWidthResize = navMaxWidth;
    }

    var NavShapeWidth = anime({
        targets: '.nav-sidebar__shape',
        width: navWidthResize,
        easing: 'easeInOutCubic',
        duration: 1200,
        delay: 200
    });

    var NavShapePath = anime({
        targets: '.js_nav-sidebar__shape-path',
        d: [
            { value: 'M0.000,0.000 C28.511,0.000 884.000,0.000 884.000,0.000 L884.000,395.009 C346.940,340.571 381.626,71.989 0.000,0.000 Z' }
        ],
        easing: 'easeInOutCubic',
        delay: 400,
        duration: 900
    });

    var morphingNavBtnIcon_return = anime({
        targets: '.nav-sidebar__icon-path',
        d: [{ value: 'M48.812,6.625 L3.844,6.625 C2.187,6.625 0.844,5.282 0.844,3.625 L0.844,3.219 C0.844,1.562 2.187,0.219 3.844,0.219 L48.812,0.219 C50.469,0.219 51.812,1.562 51.812,3.219 L51.812,3.625 C51.812,5.282 50.469,6.625 48.812,6.625 ZM3.844,14.031 L39.250,14.031 C40.907,14.031 42.250,15.374 42.250,17.031 L42.250,17.437 C42.250,19.094 40.907,20.437 39.250,20.437 L3.844,20.437 C2.187,20.437 0.844,19.094 0.844,17.437 L0.844,17.031 C0.844,15.374 2.187,14.031 3.844,14.031 ZM3.844,28.906 L28.625,28.906 C30.282,28.906 31.625,30.249 31.625,31.906 L31.625,32.312 C31.625,33.969 30.282,35.312 28.625,35.312 L3.844,35.312 C2.187,35.312 0.844,33.969 0.844,32.312 L0.844,31.906 C0.844,30.249 2.187,28.906 3.844,28.906 Z' }],
        easing: 'easeInOutCubic',
        duration: 500
    });

    // animacao de texto e icone do menu
    var morphingNavBtnIcon_return_tl = anime.timeline({
        easing: 'easeInOutCubic',
        duration: 200
    });
    morphingNavBtnIcon_return_tl
        .add({
            targets: '.js_nav-sidebar__icon-path-04',
            opacity: 0,
            scaleX: [1,0],
        })
        .add({
            targets: '.js_nav-sidebar__icon-path-05',
            opacity: 0,
            scaleX: [1,0],
        }, '-=50')
        .add({
            targets: '.js_nav-sidebar__icon-path-03',
            scaleX: 1,
            opacity: 1,
        })
        .add({
            targets: '.js_nav-sidebar__icon-path-02',
            scaleX: 1,
            opacity: 1,
        }, '-=50')
        .add({
            targets: '.js_nav-sidebar__icon-path-01',
            scaleX: 1,
            opacity: 1,
        }, '-=50');

    var morphingNavBtnText_return_tl = anime.timeline({
        easing: 'easeInOutCubic',
        duration: 100
    });
    morphingNavBtnText_return_tl
        .add({
            targets: '.js_nav-sidebar__text-span',
            opacity: 0,
        })
        .add({
            targets: '.js_nav-sidebar__text-span',
            update:function(anim) {
                setTimeout(function () {
                    $('.js_nav-sidebar__text-span').html("MENU");
                }, 200);
            },
            opacity: 1,
            delay: 450,
        });


    // animacao do aside

    // animacao login
    var asideLogin_tl = anime.timeline({
        easing: 'easeInOutCubic',
        duration: 800,
    });
    asideLogin_tl
        .add({
            targets: '.aside-login',
            opacity: 0,
            translateX: [0,80],
        })
        .add({
            targets: '.aside-login__nav .el',
            opacity: 0,
            translateX: [0,30],
            delay: function(el, i, l) {
                return i * 100;
            },
            endDelay: function(el, i, l) {
                return (l - i) * 100;
            }
        }, '-=1000');

    var asideNav = anime({
        targets: '.nav-sidebar__aside-nav .el',
        easing: 'easeInOutCubic',
        translateX: [0,60],
        opacity: 0,
        duration: 700,
        delay: function(el, i, l) {
            return i * 100;
        },
        endDelay: function(el, i, l) {
            return (l - i) * 100;
        }
    });

    setTimeout(function () {
        var asideSocial_tl = anime.timeline({
            easing: 'easeInOutCubic',
            duration: 800,
        });
        asideSocial_tl
            .add({
                targets: '.aside-social',
                opacity: 0,
                translateX: [0,80],
            })
            .add({
                targets: '.aside-social__nav .el',
                opacity: 0,
                translateX: [0,30],
                delay: function(el, i, l) {
                    return i * 100;
                },
                endDelay: function(el, i, l) {
                    return (l - i) * 100;
                }
            }, '-=1000');
    }, 400);


    // trata scroll
    $('body').css("overflow-y", "scroll");
    $('#nav-sidebar').css("overflow-y", "visible");
    setTimeout(function(){
        $('#nav-sidebar').css({
            "width": "0",
            "height": "0"
        });
    }, 1100);

    if (viewport < lg) {
        $("#nav-sidebar__collapseOne, #nav-sidebar__collapseTwo, #nav-sidebar__collapseThree, #nav-sidebar__collapseFour").collapse('hide');
    }

    navOpen = false;
}


// adjust collapse nav
function asideCollapseAdjustView() {
    if (viewport >= lg) { // lg breakpoint
        $(".nav-sidebar__btnCollapse").attr("data-toggle","false");
        $("#nav-sidebar__collapseOne, #nav-sidebar__collapseTwo, #nav-sidebar__collapseThree, #nav-sidebar__collapseFour").addClass("show");
        $(".nav-sidebar__btnCollapse").removeClass("collapsed");
    } else {
        $(".nav-sidebar__btnCollapse").attr("data-toggle","collapse");
        $("#nav-sidebar__collapseOne, #nav-sidebar__collapseTwo, #nav-sidebar__collapseThree, #nav-sidebar__collapseFour").removeClass("show");
        $(".nav-sidebar__btnCollapse").addClass("collapsed");
    }
}
